import { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ApprovalDialogBox from './ApprovalDialogBox';
import History from '@mui/icons-material/History';
import MyContext from '../../Context/AppContext';
import EditUser from '../../assets/icons/edituser';
import DataTable from '../datatable/datatable';
import { DateTime } from 'luxon';

const ApprovedUsers = ({ rows, setRows, isDataLoading, setIsDataLoading }) => {
  const { setUsageModal } = useContext(MyContext);
  const [openEditConfigDialog, setOpenEditConfigDialog] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);

  const [anchorPosition, setAnchorPosition] = useState(null);
  const [targetRow, setTargetRow] = useState(null);
  const open = Boolean(anchorPosition);
  const handleClick = (e, row) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setAnchorPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
    setTargetRow(row);
  };

  const handleClose = () => {
    setAnchorPosition(null);
  }

  const handleEditConfiguration = () => {
    setSelectedUserData(targetRow)
    setOpenEditConfigDialog(true);
    handleClose();
  };

  const handleUsageChecking = () => {
    setUsageModal({
      isOpen: true,
      userId: targetRow._id,
    });
    handleClose();

  }

  const handleApprovedUserRowChange = (targetRow, payload) => {
    const kendoData = [...rows];
    const index = kendoData.findIndex((item) => item._id === targetRow._id);
    kendoData[index].accountConfig.accountType = payload?.accountType;
    kendoData[index].accountTypeInfo = payload?.accountType;
    kendoData[index].accountConfig.jdLimit = payload?.jdLimit;
    kendoData[index].jdLimit = payload?.jdLimit;
    kendoData[index].accountTypeName = payload?.accountType?.typename;
    kendoData[index].accountConfig.contractEndDate = payload?.expiryDate;
    kendoData[index].accountExpiryDate = payload?.expiryDate;
    kendoData[index].accountConfig.permissions = payload?.permissions;
    kendoData[index].accountConfig.roleAccessId = payload?.roleAccessId;
    setRows(kendoData);
    setIsDataLoading(false);
  }

  const getFormattedDate = (raw) => {
    if (!raw) return "";
    const iso = DateTime.fromISO(raw);
    if (iso.isValid) return iso.toFormat("dd-MMM-yyyy");
    const jsDate = new Date(raw);
    if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("dd-MMM-yyyy");
    return String(raw);
  }


  const columns = [
    {
      header: "Action",
      width: "80px",
      enableSorting: false,
      enableFiltering: false,
      cell: ({ row }) => (
        <div className='buttonContainer_signupRequest'>
          <Button
            variant='contained'
            size="small"
            className='button_editConfig_approveUser'
            color="primary"
            aria-haspopup="true"
            onClick={(e) => handleClick(e, row.original)}
          >
            Action
          </Button>
        </div>
      )
    },
    {
      accessorKey: "name",
      header: "Name",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "email",
      header: "Email",
      width: "270px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "orgName",
      header: "Organization",
      width: "150px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "roleAccessName",
      header: "Role",
      width: "150px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "countryName",
      header: "Country",
      width: "150px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "contactNo",
      header: "Contact Number",
      width: "200px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "accountTypeName",
      header: "Account Type",
      width: "150px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "approvedByName",
      header: "Approved By",
      width: "150px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "approvalDate",
      header: "Approval Date",
      width: "150px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => (
        (() => {
          const raw = getFormattedDate(row.original.approvalDate);
          return raw;
        }))()
    },
    {
      accessorKey: "accountExpiryDate",
      header: "Account Expiry Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => (
        (() => {
          const raw = getFormattedDate(row.original.accountExpiryDate);
          return raw;
        }))()
    }
  ]

  return (
    <>
      <Menu
        id="basic-menu"
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleEditConfiguration()} className='menuItem_approvedUserTable'>
          <EditUser />
          <span>Edit configuration</span>
        </MenuItem>
        <MenuItem onClick={() => handleUsageChecking()} className='menuItem_approvedUserTable'>
          <History />
          <span>Usage history</span>
        </MenuItem>
      </Menu>
      <div className="grid-container">
        <DataTable
          data={rows}
          columns={columns}
          isLoading={isDataLoading}
          enableFiltering={true}
          enablePagination={true}
          enableSorting={false}
          pageSizeOptions={[10, 20, 50, 100]}
          noDataText="No results found !"
        />
      </div>
      <ApprovalDialogBox
        open={openEditConfigDialog}
        handleClose={() => setOpenEditConfigDialog(false)}
        isEdit={true}
        userData={selectedUserData}
        setKendoDataLoading={setIsDataLoading}
        handleApprovedUserRowChange={handleApprovedUserRowChange}
      />
    </>
  );
}

export default ApprovedUsers;
